<template>
  <div v-if="shouldDisplayCarriers">
    <ReassuranceItem
      class="w-full"
      has-link
      @click="deployCarriersCompatibilityModal"
    >
      <template #icon>
        <RevIllustration
          v-if="logo"
          :alt="carrier?.name ?? ''"
          class="h-24 w-24 md:h-32 md:w-32"
          :height="48"
          :src="logo"
          :width="48"
        />
        <IconLockUnlocked
          v-if="!isSimLocked"
          class="h-24 w-24 md:h-32 md:w-32"
        />
      </template>
      <template #title>
        <div v-if="isSimLocked" class="w-full">
          {{ carrier.name }}
          {{ i18n(translations.lockTitle) }}
        </div>

        <div v-if="!isSimLocked" class="w-full">
          {{ i18n(translations.unlockTitle) }}
        </div>
      </template>
      <template #subtitle>
        <div v-if="isSimLocked" class="w-full">
          {{ i18n(translations.lockSubtitle) }}
        </div>

        <div v-if="!isSimLocked" class="w-full">
          {{ i18n(translations.unlockSubtitle) }}
        </div>
      </template>
    </ReassuranceItem>
    <CarriersCompatibilityModal :type="isSimLocked ? 'locked' : 'unlocked'" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { isEmpty } from '@backmarket/utils/object/isEmpty'
import { RevIllustration } from '@ds/components/Illustration'
import { openModal } from '@ds/components/ModalBase'
import { IconLockUnlocked } from '@ds/icons/IconLockUnlocked'

import { MODAL_NAMES } from '~/scopes/product/constants'

import CarriersCompatibilityModal from '../CarriersCompatibilityModal/CarriersCompatibilityModal.vue'
import ReassuranceItem from '../ReassuranceItem/ReassuranceItem.vue'

import translations from './ItemCarrier.translations'

const carriersLogoMap: Record<string, string> = {
  Verizon: 'verizon.png',
  'AT&T': 'att.png',
  'T-Mobile': 'tmobile.png',
}

const props = defineProps<{
  carrier: GetProductResponse['carrier']
  tracking: Record<string, string>
}>()

const i18n = useI18n()
const { trackClick } = useTracking()

const shouldDisplayCarriers = computed(() => {
  return !isEmpty(props.carrier) && props.carrier.isDisplayed
})

const isSimLocked = computed(() => {
  return props.carrier.locked
})

const logo = computed(() => {
  return props.carrier.name && props.carrier.name in carriersLogoMap
    ? `/img/product/carriers/${carriersLogoMap[props.carrier.name]}`
    : ''
})

function deployCarriersCompatibilityModal(event: MouseEvent) {
  trackClick(props.tracking)
  openModal(MODAL_NAMES.CARRIERS_COMPATIBILITY, event)
}
</script>
